import React from 'react';
import ButtonsSearch from '../../../../../../components/NovoSistema/ButtonsSearch';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import DoubleInput from '../../../../../../components/NovoSistema/DoubleInput';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function AjusteDeSaldo() {
  return (
    <main>
      <ContainerSection>
        <WrapperInputsNewSystem>
          <InputDate title="Data de Ajuste" id="DataDeAjuste" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Tipo de Ajuste"
            id="TipoDeAjueste"
            optionsArray={[
              '',
              'Saldo Inicial',
              'Ajuste de Saldo',
              'Transferência por Localização',
              'Custo Médio Inicial',
            ]}
            widthPercentage="20%"
          />
        </WrapperInputsNewSystem>
        <ContainerSection>
          <h3>Filtro</h3>
          <WrapperInputsNewSystem>
            <DoubleInput title="Produto" id="Produto" widthPercentage="30%" />
            <SelectAndOptions
              title="Tipo de Produto"
              id="TipoDeProduto"
              optionsArray={[
                '',
                'Mercadoria para revender',
                'Matéria Prima',
                'Embalagem',
                'Produto em processo',
                'Produto acabado',
                'Subproduto',
                'Produto intermediário',
                'Material de uso e consumo',
                'Ativo Imobilizado',
                'Outros insumos',
                'Outras',
              ]}
              widthPercentage="20%"
            />
            <SelectAndOptions
              title="Bloqueado"
              id="Bloqueado"
              optionsArray={['Todos', 'Sim', 'Não']}
              widthPercentage="20%"
            />
            <SelectAndOptions
              title="Situação"
              id="Situacao"
              optionsArray={['Todas', 'Ativo', 'Inativo']}
              widthPercentage="20%"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <DoubleInput title="Localização" id="Localizacao" widthPercentage="30%" />
            <InputText title="Código de Barras" id="CodigoDeBarras" widthPercentage="30%" />
            <InputText title="NCM" id="NCM" widthPercentage="30%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Divisão Gerencial"
              id="DivisaoGerencial"
              optionsArray={['', 'Grupo', 'Marca', 'Fabricante', 'Familia', 'SubTipo', 'Linha', 'Departamento']}
              widthPercentage="20%"
            />
            <DoubleInput title="Inicial" id="Inicial" widthPercentage="30%" />
            <DoubleInput title="Final" id="Final" widthPercentage="30%" />
            <ButtonsSearch />
          </WrapperInputsNewSystem>
        </ContainerSection>
        <ContainerSection>
          <h3>Dados do Ajuste</h3>
        </ContainerSection>
        <ButtonsGeneric>
          <button className="normal">Processar</button>
        </ButtonsGeneric>
      </ContainerSection>
    </main>
  );
}
